import DailyWeathers from './DailyWeathers.component';

export default DailyWeathers;